export default "__VITE_ASSET__CB15ESJ0__"